import type { FarmEvent, FarmState } from './model';
import { createDomain } from './farm';
import { todayISO } from './dates';
import { captureCompletedTask } from './history';
import {FEED_CHANGE_CATEGORY,isFeedChangeEvent} from './protocolCategories';

export interface CalendarFilter { area: string; type: string; status: string }
export function filterCalendar(state: FarmState, filter: CalendarFilter, today=todayISO()): FarmEvent[] {
  const domain=createDomain(state);
  return domain.generateAllEvents().filter(event=> {
    if(filter.area!=='todas' && domain.eventArea(event)!==filter.area) return false;
    if(filter.type===FEED_CHANGE_CATEGORY?!isFeedChangeEvent(event):filter.type!=='todos' && event.tipo!==filter.type) return false;
    const done=domain.isDone(event.doneKey);
    switch(filter.status){
      case 'pendientes': return event.date>=today && !done;
      case 'vencidas': return !!event.date && event.date<today && !done;
      case 'terminadas': return done;
      case 'sinFecha': return !event.date;
      default: return true;
    }
  }).sort((a,b)=>(a.date||'9999').localeCompare(b.date||'9999') || a.prioridad-b.prioridad || a.label.localeCompare(b.label));
}

export function toggleTask(state: FarmState, key: string): void {
  const index=state.tareasHechas.indexOf(key);
  if(index<0) {
    const snapshot=captureCompletedTask(state,key);
    state.tareasHechas.push(key);
    // A cleared/reprogrammed key can be reused without erasing its earlier realizations.
    state.tareasRealizadas=[...(state.tareasRealizadas || []).map(item=>item.doneKey===key?{...item,archived:true}:item),snapshot];
  } else {
    state.tareasHechas=state.tareasHechas.filter(item=>item!==key);
    const snapshots=state.tareasRealizadas;
    let activeIndex=-1;
    for(let index=(snapshots?.length || 0)-1;index>=0;index--) {
      if(snapshots![index].doneKey===key && !snapshots![index].archived){activeIndex=index;break;}
    }
    if(snapshots && activeIndex>=0)state.tareasRealizadas=snapshots.filter((_,index)=>index!==activeIndex);
  }
}
